export const AppConfig = {
  constants: {
    EMAIL_ID_REGEX: new RegExp('^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,10}$'),
  },

  requestWithdrawal: 'api/withdrawals/requestWithdrawal',
  getWithdrawalsHistory: 'api/withdrawals/getWithdrawalsHistory',
  cancelTransaction: 'api/transactions/cancelTransaction/'
}